import { getExpressionData } from "api/expression";
import { getTagData } from "api/tags";
import areaApiConfig from "./areaApiConfig";

const unityGaugeBarConfig = {
  getTagData,
  getExpressionData,
  areaApiConfig
};

export default unityGaugeBarConfig;